/**
 * Contenu pédagogique de Néopolis 2040.
 *
 * Règle non négociable n° 2 : zéro contenu en dur dans le code. Tous les textes,
 * chiffres, équipements, solutions et événements viennent d'ici.
 *
 * Règle n° 3 : le JSON est validé **au build** (`pnpm validate:content`, exécuté
 * avant `pnpm build` et en CI) **et dans un test** (`index.test.ts`). Il ne l'est
 * volontairement pas à l'exécution : cela embarquerait Zod dans le bundle envoyé
 * aux tablettes, soit une cinquantaine de kilo-octets pour revérifier un fichier
 * déjà vérifié deux fois. Le réseau d'un collège ne les a pas à perdre.
 */
import type { Content } from '@neopolis/engine';
// L'attribut d'import est nécessaire dès que ce module est chargé par Node sans
// bundler — c'est le cas des tests Playwright.
import raw from '../neopolis-contenu-mvp.json' with { type: 'json' };

/** Nom du fichier source, utile pour les messages d'erreur et les outils. */
export const CONTENT_FILENAME = 'neopolis-contenu-mvp.json';

/** Le contenu du MVP. Sa conformité au schéma est garantie par le build et les tests. */
export const content = raw as unknown as Content;

export type { Content };
